const $ = jQuery


import Search from '../Search'


export default class AbstractHeader {
    constructor($root, baseClass) {
        this._baseClass = baseClass
        this._active = true
        this.root = $root
        this.parentContainer = this.root.parent()
        this.search = new Search(this.find('search'))
        this.search.on('searchEnd', () => this.limitSearchHeight())
    }

    limitSearchHeight() {}

    hideMenus() {}

    bindControls() {
        this.search.on('close', () => this.hideMenus())
    }

    get active() {
        return this._active
    }

    get inactive() {
        return !this._active
    }

    find(subSelector) {
        return this.root.find(`.${this._baseClass}-${subSelector}`)
    }

    attach() {
        this.parentContainer.prepend(this.root)
        this._active = true
    }

    detach() {
        this.hideMenus()
        this.root.detach()
        this._active = false
    }

    minimize() {
        this.root
            .addClass('header-min')
            .removeClass('header-max')
        return this
    }

    maximize() {
        this.root
            .addClass('header-max')
            .removeClass('header-min')
        return this
    }
}
